import {NgModule} from '@angular/core';
import {SaleSearchComponent} from "./sale-search.component";
import {SelectSearchDataModule} from "../../../../../components/common/select-search-data/select-search-data.module";

@NgModule({
    declarations: [
        SaleSearchComponent,
    ],
    exports: [
        SaleSearchComponent
    ],
    imports: [
        SelectSearchDataModule,
    ]
})
export class SaleSearchModule {
}
